module.exports = __webpack_public_path__ + "img/254.6da76f05.jpg";